import { render } from "./LinkBttn.vue?vue&type=template&id=7268837e"
import script from "./LinkBttn.vue?vue&type=script&lang=js"
export * from "./LinkBttn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__